import { render, staticRenderFns } from "./FilterOrders.vue?vue&type=template&id=6217413f&lang=pug"
import script from "./FilterOrders.vue?vue&type=script&lang=js"
export * from "./FilterOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports